import React, { useCallback, useRef, useState } from 'react';

/**
 * Lightweight toast stack. Extracted from TestCasePage so the project / suite /
 * case pages can share it.
 *
 * Usage:
 *   const { toasts, showToast, dismissToast } = useToasts();
 *   ...
 *   <Toast toasts={toasts} onDismiss={dismissToast} />
 */
export function useToasts() {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  const dismissToast = useCallback((id) => {
    clearTimeout(timers.current[id]);
    delete timers.current[id];
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const showToast = useCallback((message, type = 'success') => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type }]);
    timers.current[id] = setTimeout(() => dismissToast(id), 3000);
  }, [dismissToast]);

  return { toasts, showToast, dismissToast };
}

function Toast({ toasts, onDismiss }) {
  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          <span className="toast-icon">{t.type === 'success' ? '✓' : 'ℹ'}</span>
          <span className="toast-message">{t.message}</span>
          <button className="toast-close" onClick={() => onDismiss(t.id)}>×</button>
        </div>
      ))}
    </div>
  );
}

export default Toast;
